module.exports = __webpack_public_path__ + "static/home-ourproduct-paas-43054f4c8073fa609aa0ebe2dc60b6fe.png";